// extracted by mini-css-extract-plugin
module.exports = {"image":"_3CY0vu7"};